import { CategoryFormData } from "@/formTypes/CategoryFormDataType";
import { GenericModelApi } from "./GenericModelApi";
import { ApiSchema } from "./ApiClient";

export type CategoryDataType = Partial<ApiSchema["Category"]["type"] & CategoryFormData>;
export const CategoryApi = new GenericModelApi<"Category", CategoryDataType>("Category", "nombre");